// Libraries
import _ from 'lodash';
import React from 'react';

// Supermove
import {DataLoader, Styled} from '@supermove/components';
import {gql, useQuery} from '@supermove/graphql';
import {useEffect} from '@supermove/hooks';
import {UserCalendarEventModel, UserModel} from '@supermove/models';
import {MomentType} from '@supermove/utils/src/Datetime';

// App
import UserCalendar from '@shared/modules/UserCalendar/components/UserCalendar';
import {
  getTimeRangeForViewType,
  USER_CALENDAR_VIEW_TYPE,
} from '@shared/modules/UserCalendar/enums/UserCalendarViewType';

const LoadingIndicator = Styled.Loading`
`;

const SalespersonCalendarView = ({
  selectedUserWithCalendarId,
  jobDate,
  calendarsPerPage,
}: {
  selectedUserWithCalendarId: {user: UserModel; calendarId: string}[];
  jobDate?: MomentType;
  calendarsPerPage: number;
}) => {
  const timeRange = getTimeRangeForViewType(USER_CALENDAR_VIEW_TYPE.DAY, jobDate || undefined);
  const {startDate, endDate} = timeRange;

  const userIdWithCalendarIdList = selectedUserWithCalendarId.map(({user, calendarId}) => ({
    userId: _.toNumber(user.id),
    calendarId,
  }));

  const {data, loading, refetch} = useQuery<{userCalendarEvents: UserCalendarEventModel[]}>(
    SalespersonCalendarView.query,
    {
      variables: {
        userIdWithCalendarIdList,
        startDate,
        endDate,
      },
    },
  );

  useEffect(() => {
    refetch();
  }, [selectedUserWithCalendarId]);

  const calendars = selectedUserWithCalendarId.map(({user, calendarId}) => ({
    userId: _.toString(user.id),
    calendarId,
    title: user.fullName,
  }));

  return (
    <DataLoader data={data} loading={loading || !data} as={LoadingIndicator}>
      {({loadedData}) => (
        <UserCalendar
          events={loadedData.userCalendarEvents}
          calendars={calendars}
          calendarsPerPage={calendarsPerPage}
          startDate={startDate.toDate()}
          viewType={USER_CALENDAR_VIEW_TYPE.DAY}
          views={[USER_CALENDAR_VIEW_TYPE.DAY]}
        />
      )}
    </DataLoader>
  );
};

SalespersonCalendarView.query = gql`
  query SalespersonCalendarView(
    $userIdWithCalendarIdList: [UserIdWithCalendarIdInput!]!
    $startDate: String!
    $endDate: String!
  ) {
    userCalendarEvents(
      userIdWithCalendarIdList: $userIdWithCalendarIdList
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      calendarId
      title
      status
      description
      textDescription
      whenType
      startTime
      endTime
      dateValue
      startDate
      endDate
    }
  }
`;
export default SalespersonCalendarView;
